// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal___1CEQH"};